import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { SponsorGroupEffects } from './features/sponsor-group/sponsor-group.effects';
import { SponsorGroupNameComponent } from './components/modals/sponsor-group-name/sponsor-group-name.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';

import * as fromSponsorGroup from './features/sponsor-group/sponsor-group.reducer';
import { StoreModule } from '@ngrx/store';

@NgModule({
  declarations: [SponsorGroupNameComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    CoreModule,
    StoreModule.forFeature(fromSponsorGroup.sponsorGroupFeatureKey, fromSponsorGroup.reducer),
    EffectsModule.forFeature([SponsorGroupEffects])
  ]
})
export class SponsorGroupModule { }
